<div *transloco="let translate">
    <div class="d-flex align-items-center matDialogBorderBottom" [ngClass]="{ 'justify-content-between': isPopup, 'justify-content-end': !isPopup }">
        <h4 *ngIf="isPopup" class="matDialogTitle ml-[10px]" mat-dialog-title [textContent]="translate('Process Logs')"></h4>
        <div class="header-actions">
            <material-button [buttonType]="'mini-fab'" class="refreshLogs mx-2 my-2 !shadow-none" [titleText]="translateMsg('Refresh')" [prefixIcon]="'refresh'" (buttonClicked)="refreshProcessLogs()"></material-button>
            <span *ngIf="isPopup" class="material-icons mb-1" mat-dialog-close>close</span>
        </div>
    </div>
    <div class="eventTable">
        <material-table [allTableColumns]="allTableColumns" [selectedColumns]="selectedColumns" [data]="tableData" [noLog]="true" [noRecordMsg]="translateMsg('No Process Logs Available')" [defaultPaginator]="true"></material-table>
    </div>
</div>
